import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IImportSettingsCibcSftp } from './import-settings-cibc-sftp.model';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ImportSettingsCibcSftpService {

  constructor(
    private http: HttpClient,
  ) { }

  public get(bankAccountId: number): Observable<IImportSettingsCibcSftp> {
    const url = `${environment.api}/v2/bank-accounts/${bankAccountId}/import-settings/cibc-sftp`;
    return this.http.get<IImportSettingsCibcSftp>(url);
  }

  public save(bankAccountId: number, settings: IImportSettingsCibcSftp): Promise<void> {
    const url = `${environment.api}/v2/bank-accounts/${bankAccountId}/import-settings/cibc-sftp`;
    return this.http.post<void>(url, settings).toPromise();
  }

}
